export default "__VITE_ASSET__B2Duv7iE__"